import axios from "axios";
import * as types from '../constants/ActionTypes'

// Url's
// const getOrderListUrl = `${process.env.REACT_APP_API_URL}api/csa-app/get-order-list`;
const getOrderListUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaprofile/get-order-list`;


// Actions
const orderListRequested = () => ({
    type: types.ORDERLIST_REQUEST
  });

const orderListSuccess = data => ({
  type: types.ORDERLIST_SUCCESS,
  data
});

const orderListFailure = error => ({
  type: types.ORDERLIST_FAILURE,
  error
});


// API
export const getOrderList = (connection_id, mobile,tenant_name) => {
  return dispatch => {
    dispatch(orderListRequested());
    axios.get(getOrderListUrl, {
      params: {
        connection_id,
        mobile_no: mobile,
        tenant_name:tenant_name
      },
    })
      .then(res => {
        if (res.data.ack === "Success") {
            // 
          dispatch(orderListSuccess(res.data.results));
        } else if (res.data.ack === "Failure") {
          dispatch(orderListFailure(res.data.status));
        } 
      })
      .catch(err => {
          throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};
